// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UhB1x","left":"styles_left__1-Jr1"};